/* eslint-disable camelcase */
import axios from 'axios';

export default {

  async sendSuscription(email, type, full_name) {
    return axios.post('/api/v1/mail/suscription', {
      email,
      type,
      full_name,
    });
  },

};
